import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '~/lib/api'

/*
  How often the screens that follow a live WhatsApp thread refetch. A student
  writes and the agent answers while someone is watching the page, so waiting
  for a manual refresh means watching a stale thread.

  Polling rather than Action Cable: one endpoint, no websocket to keep open
  through nginx, and the payloads are small. React Query stops the timer when
  the tab loses focus, so an idle tab costs nothing.
*/
export const LIVE_REFETCH_MS = 10_000

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // A 401 means "not signed in" — retrying it just delays the redirect.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status === 401 ? false : failureCount < 2,
    },
  },
})
